import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-eraser-icon',
  templateUrl: './design-eraser.component.html'
})
export class DesignEraserComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
